import { useEffect } from 'react';

export type UseStyleInput = CSSString | any;

type CSSString = string;

export function useStyle(input: UseStyleInput) {
    useEffect(() => {
        if (input) {
            const style = document.createElement('style');

            style.innerHTML = input;

            document.documentElement.appendChild(style);

            return () => {
                document.documentElement.removeChild(style);
            };
        }
    }, [input]);
}
